<template>
  <el-dropdown trigger="click" @command="handleCommand">
    <span class="flag-button">
      {{ LOCALE_FLAGS[currentLocale as LocaleKey] }}
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item 
          v-for="(flag, locale) in LOCALE_FLAGS" 
          :key="locale"
          :command="locale"
          :class="{ active: locale === currentLocale }"
        >
          {{ flag }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { LOCALE_FLAGS, type LocaleKey } from '../i18n/constants'
import { onMounted } from 'vue'
import { useAuthStore } from '../stores/auth'
const { locale } = useI18n()
const currentLocale = computed(() => locale.value)

const handleCommand = (command: string) => {
  locale.value = command
}
 // Assuming these functions are defined in a utils file

const authStore = useAuthStore()

onMounted(() => {
  if (!authStore.language) {
    if (!authStore.language) {
      useI18n().locale.value = navigator.language.split('-')[0] || 'pt';
      if (useI18n().locale.value === 'pt') {
        useI18n().locale.value = 'pt_BR';
      } else if (useI18n().locale.value === 'de') {
        useI18n().locale.value = 'de_DE';
      } 
      authStore.language = useI18n().locale.value;
    }
  }
});
</script> 

<style scoped>
.flag-button {
  cursor: pointer;
  font-size: 1.5rem;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.flag-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.active {
  background-color: #f0f0f0;
}

:deep(.el-dropdown-menu__item) {
  font-size: 1.2rem;
  padding: 8px 16px;
}
</style> 